'use client';
import { useContext } from 'react';
import { OverlayContext } from './OverlayContext';

export const useOverlay = () => useContext(OverlayContext);
